export const APP_ROUTES = {
  MAIN: '/main',
  DASHBOARD: '/main/dashboard',
  KNOWLEDGE_BASE: '/main/knowledge-base',
  PLAYGROUND: '/main/playground',
  ASSISTANT: '/main/assistant',
  CALLS: '/main/calls',
  LIZZIE: '/main/lizzie',
  COLD_CALLS: '/main/cold-calls',
  DEAL_ROOMS: '/main/deal-rooms',
  PROFILE: '/main/profile',
  USER_SETTINGS: '/main/user-settings',
  IMPORT_DOCUMENT: '/main/create-new-document/import-document',
};
